import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { StoreFront, StoreFrontSkeleton } from "@/features/presets/components/StoreFront";
import { presetListingsQuery } from "@/features/presets/queries";

export const Route = createFileRoute("/_authenticated/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(presetListingsQuery()),
  head: () => ({ meta: [{ title: "Scenarios · Pax.co" }] }),
  pendingComponent: StoreFrontSkeleton,
  component: StorePage,
});

function StorePage() {
  const router = useRouter();
  const { data } = useSuspenseInfiniteQuery(presetListingsQuery());
  const listings = data.pages.flatMap(page => page.items);
  const firstSlug = listings[0]?.slug;

  // Almost every visit to the store ends in a scenario, and the travel there
  // cannot start until the scenario route's code has arrived. Fetch it while
  // the store is idle, so the first press moves as fast as the second.
  useEffect(() => {
    if (!firstSlug) return;
    const warm = () =>
      void router.preloadRoute({ to: "/presets/$slug", params: { slug: firstSlug } });
    if (typeof window.requestIdleCallback === "function") {
      const handle = window.requestIdleCallback(warm);
      return () => window.cancelIdleCallback(handle);
    }
    const timer = window.setTimeout(warm, 500);
    return () => window.clearTimeout(timer);
  }, [router, firstSlug]);

  return <StoreFront listings={listings} />;
}
